<template>
  <v-card class="mt-6">
    <v-card-title>
      Alerta de Dados de Hóspedes
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-switch
            :value="config.guest_data_alert_enabled"
            color="primary"
            inset
            label="Ativar"
            @change="updateField('guest_data_alert_enabled', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.guest_data_alert_time"
            type="time"
            outlined
            :error="guestDataAlertInput.error"
            :error-messages="guestDataAlertInput.message"
            :disabled="!config.guest_data_alert_enabled"
            label="Horário"
            @input="updateField('guest_data_alert_time', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.guest_data_alert_interval"
            type="number"
            outlined
            :error="guestDataAlertIntervalInput.error"
            :error-messages="guestDataAlertIntervalInput.message"
            :disabled="!config.guest_data_alert_enabled"
            label="Intervalo entre alertas (min)"
            @input="updateField('guest_data_alert_interval', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'GuestDataAlertSettings',
  props: {
    config: {
      type: Object,
      required: true,
    },
    guestDataAlertInput: {
      type: Object,
      default: () => ({ error: false, message: '' }),
    },
    guestDataAlertIntervalInput: {
      type: Object,
      default: () => ({ error: false, message: '' }),
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
